<template>
  <div class="nav fixed z-30 bottom-0 bg-white/90 backdrop-blur-md border-t border-gray-100 h-16 flex items-center shadow-floating w-full">
    <div
      @click="redirectTo('Home')"
      :class="['w-1/3 flex flex-col justify-center items-center py-1 transition-all active:scale-95 cursor-pointer select-none', {'item': isHome, 'item-outline': !isHome}]">
      <img v-if="isHome" class="w-6 h-6 transition-transform scale-110" src="~@/assets/icons/menu/house-blue.svg" alt="house">
      <img v-else class="w-6 h-6 transition-transform opacity-70 group-hover:opacity-100" src="~@/assets/icons/menu/house-blue.svg" alt="house">
      <div class="text-xs font-semibold mt-1">Home</div>
    </div>
    <div
      @click="redirectTo('Fellowship')"
      :class="['w-1/3 flex flex-col justify-center items-center py-1 transition-all active:scale-95 cursor-pointer select-none', {'item': isFellowShip, 'item-outline': !isFellowShip}]">
      <img v-if="isFellowShip" class="w-6 h-6 transition-transform scale-110" src="~@/assets/icons/menu/fellowship-blue.svg" alt="people">
      <img v-else class="w-6 h-6 transition-transform opacity-70 group-hover:opacity-100" src="~@/assets/icons/menu/fellowship-blue.svg" alt="people">
      <div class="text-xs font-semibold mt-1">Persekutuan</div>
    </div>
    <div
      @click="redirectTo('Schedule')"
      :class="['w-1/3 flex flex-col justify-center items-center py-1 transition-all active:scale-95 cursor-pointer select-none', {'item': isSchedule, 'item-outline': !isSchedule}]">
      <img v-if="isSchedule" class="w-6 h-6 transition-transform scale-110" src="~@/assets/icons/menu/calendar-blue.svg" alt="calendar">
      <img v-else class="w-6 h-6 transition-transform opacity-70 group-hover:opacity-100" src="~@/assets/icons/menu/calendar-blue.svg" alt="calendar">
      <div class="text-xs font-semibold mt-1">Jadwal</div>
    </div>
  </div>
</template>

<script>
import location from '@/mixins/location'
export default {
  name: 'BottomNavigation',
  mixins: [location],
  methods: {
    redirectTo (name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  max-width: 600px;
}
.item {
  @apply text-blue-600 font-bold border-t-2 border-blue-600;
}
.item-outline {
  @apply text-gray-400 font-normal hover:text-gray-600;
}
</style>
